import { useOutletContext, Link } from 'react-router-dom';
import { ArrowRight, Globe2, Package } from 'lucide-react';
import type { OutletCtx } from '@/layouts/AdminLayout';
import { ChangeLogPanel } from '@/components/ChangeLogPanel';

export default function DashboardPage() {
  const { sites } = useOutletContext<OutletCtx>();
  const totalItems = sites.reduce((sum, s) => sum + s.active_item_count, 0);
  const totalCategories = sites.reduce((sum, s) => sum + s.category_count, 0);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">대시보드</h1>
        <p className="text-sm text-muted-foreground">멀티 사이트 공통 콘텐츠 관리</p>
      </div>

      <div className="grid gap-4 md:grid-cols-3">
        <StatCard icon={<Globe2 className="h-5 w-5" />} label="사이트" value={sites.length} />
        <StatCard icon={<Package className="h-5 w-5" />} label="카테고리" value={totalCategories} />
        <StatCard icon={<Package className="h-5 w-5" />} label="활성 아이템" value={totalItems} />
      </div>

      <div className="grid gap-6 lg:grid-cols-[1fr_320px]">
        <div className="rounded-md border bg-card">
          <div className="border-b px-4 py-2 text-sm font-semibold">사이트 목록</div>
          {sites.length === 0 ? (
            <div className="p-6 text-sm text-muted-foreground">
              등록된 사이트가 없습니다. 좌측 사이드바의 + 버튼으로 추가하세요.
            </div>
          ) : (
            <ul>
              {sites.map((s) => (
                <li key={s.id} className="border-b last:border-b-0">
                  <Link
                    to={`/admin/sites/${s.slug}`}
                    className="flex items-center justify-between px-4 py-3 text-sm hover:bg-accent"
                  >
                    <div>
                      <div className="font-medium">{s.name}</div>
                      <div className="text-xs text-muted-foreground">
                        /{s.slug} · {s.category_count} 카테고리 · {s.active_item_count} 활성
                      </div>
                    </div>
                    <ArrowRight className="h-4 w-4 text-muted-foreground" />
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </div>

        <ChangeLogPanel reloadKey={0} />
      </div>
    </div>
  );
}

function StatCard({ icon, label, value }: { icon: React.ReactNode; label: string; value: number }) {
  return (
    <div className="rounded-md border bg-card p-4">
      <div className="flex items-center gap-2 text-muted-foreground">
        {icon}
        <span className="text-xs">{label}</span>
      </div>
      <div className="mt-2 text-3xl font-bold">{value}</div>
    </div>
  );
}
